export default function AirHockeyIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <rect x="5" y="12" width="54" height="40" rx="8" fill="none" stroke="#3B434F" strokeWidth="3" />
      <path d="M32 12v40" stroke="#3B434F" strokeWidth="2" />
      <circle cx="17" cy="38" r="8" fill="#2F8BFF" />
      <circle cx="47" cy="25" r="8" fill="#FF8A1F" />
      <circle cx="31" cy="28" r="4.5" fill="#E7ECF3" />
    </svg>
  );
}
